import { render, staticRenderFns } from "./ListAppliedTaxOnOrder.vue?vue&type=template&id=6bb2cc78&"
import script from "./ListAppliedTaxOnOrder.vue?vue&type=script&lang=js&"
export * from "./ListAppliedTaxOnOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bb2cc78')) {
      api.createRecord('6bb2cc78', component.options)
    } else {
      api.reload('6bb2cc78', component.options)
    }
    module.hot.accept("./ListAppliedTaxOnOrder.vue?vue&type=template&id=6bb2cc78&", function () {
      api.rerender('6bb2cc78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Listing/ListAppliedTaxOnOrder.vue"
export default component.exports